import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";   // ⬅️ NEW
import { useNavigate } from "react-router-dom";

import {
  FaMapMarkerAlt,
  FaDollarSign,
  FaClock,
  FaCalendarAlt,
  FaSyncAlt,
  FaList,
  FaExchangeAlt,
} from "react-icons/fa";
import logo from "../assets/logo.png";
import { API_BASE_URL } from "../config";

// ✅ Helper: Convert numeric durations to human-readable times
const formatDuration = (hours) => {
  if (!hours) return "N/A";
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  const hourText = h > 0 ? `${h} hr${h > 1 ? "s" : ""}` : "";
  const minText = m > 0 ? `${m} min${m > 1 ? "s" : ""}` : "";
  return `${hourText}${hourText && minText ? " " : ""}${minText}` || "N/A";
};


const SidebarSection = ({ title, items }) => {
  return (
    <div style={{ marginBottom: "20px" }}>
      <div
        style={{
          fontWeight: "bold",
          fontSize: "1rem",
          marginBottom: "10px",
          borderBottom: "1px solid rgba(255,255,255,0.3)",
          paddingBottom: "5px",
        }}
      >
        {title}
      </div>

      {items.map((item) => (
        <Link key={item.to} to={item.to} style={{ textDecoration: "none" }}>
          <button
            style={{
              width: "100%",
              padding: "10px",
              marginBottom: "8px",
              backgroundColor: "#388e3c",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              justifyContent: "center",
            }}
          >
            {item.icon} {item.label}
          </button>
        </Link>
      ))}
    </div>
  );
};


const Listings = () => {


  
    const navigate = useNavigate();

  const ROUTES = {
    "Lawn Mowing": {
      listings: "/listings",
      swaps: "/swaps",
    },
    Cleaning: {
      listings: "/cleaning/listings",
      swaps: "/cleaning/swaps",
    },
    "Pool Care": {
      listings: "/poolcare/listings",
      swaps: "/poolcare/swaps",
    },
  };

  const [listings, setListings] = useState([]);

const [filters, setFilters] = useState({
  category: "Lawn Mowing",
  view: "listings",
  state: "",
  postcode: "",
});

const isMobile = window.innerWidth <= 768;

  

    const routerLocation = useLocation();  // ✅ MUST BE HERE

  const options = {
    category: ["Lawn Mowing", "Cleaning", "Pool Care"],
    type: ["Sell", "Swap"], // ✅ FIXED HERE
    state: ["NSW", "VIC", "QLD", "SA", "WA", "TAS", "NT", "ACT"],
  };

 

 useEffect(() => {
  const params = new URLSearchParams(routerLocation.search);
  const search = params.get("search") || "";
  const category = params.get("category") || "";

  const query = new URLSearchParams();

  if (search) query.append("search", search);
  if (category) query.append("category", category);

  fetch(`${API_BASE_URL}/api/listings?${query.toString()}`)
    .then((res) => {
      if (!res.ok) throw new Error(`Server returned ${res.status}`);
      return res.json();
    })
    .then((data) => setListings(data))
    .catch((err) => console.error("❌ Failed to fetch listings:", err));
}, [routerLocation.search]);

const filteredListings = listings.filter((listing) => {
  const matchState =
    !filters.state || listing.state === filters.state;

  const matchPostcode =
    !filters.postcode || listing.postcode?.includes(filters.postcode);

  return matchState && matchPostcode;
});




  const getImageSrc = (image) => (image ? image : "/images/Grass.jpg");

  const buttonStyle = {
    width: "100%",
    padding: "12px",
    backgroundColor: "#2e7d32",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    justifyContent: "center",
    marginBottom: "10px",
  };

const selectStyle = {
  width: "100%",
  padding: isMobile ? "6px" : "10px",
  marginBottom: isMobile ? "6px" : "15px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: isMobile ? "0.9rem" : "1rem",
};
  const cardStyle = {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    overflow: "hidden",
    transition: "transform 0.2s ease",
    position: "relative",
  };

  const viewButton = {
    width: "100%",
    marginTop: "8px",
    backgroundColor: "#2e7d32",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  };

  const columns = window.innerWidth <= 768 ? 1 : 2;

  return (
<div
  style={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    minHeight: "100vh",
    overflow: "hidden",
    backgroundColor: "#f4f7f9",
  }}
>
      {/* Sidebar Filters */}
  <aside
  style={{
    width: isMobile ? "100%" : "250px",
    backgroundColor: "#2e7d32",
    color: "#fff",
    padding: isMobile ? "4px 6px" : "20px",
    height: isMobile ? "auto" : "100vh",
    overflowY: isMobile ? "visible" : "auto",
    textAlign: "center",
  }}
>
        <img
          src={logo}
          alt="Client Exchange Logo"
          style={{ width: "140px", margin: "0 auto 25px" }}
        />
   

    
        

        {/* Filter Controls */}
        <div style={{ marginTop: "20px", textAlign: "left" }}>
       

<label style={{ fontWeight: "bold" }}>Category:</label>
<select
  value={filters.category}
  onChange={(e) => {
    const category = e.target.value;
    setFilters({ ...filters, category });

    if (category === "Lawn Mowing") navigate("/listings");
    if (category === "Cleaning") navigate("/cleaning/listings");
    if (category === "Pool Care") navigate("/poolcare/listings");
  }}
  style={selectStyle}
>
  <option value="Lawn Mowing">Lawn Mowing</option>
  <option value="Cleaning">Cleaning</option>
  <option value="Pool Care">Pool Care</option>
</select>


<label style={{ fontWeight: "bold" }}>View:</label>
<select
  value={filters.view}
  onChange={(e) => {
    const view = e.target.value;
    setFilters({ ...filters, view });

    if (view === "listings") {
      navigate("/listings");
    }

    if (view === "swaps") {
      navigate("/swaps");
    }

    if (view === "rounds") {
      navigate("/lawn-mowing/rounds");
    }

    if (view === "business") {
  navigate("/lawn-mowing/business");
}
  }}
  style={selectStyle}
>
  <option value="listings">Listings</option>
  <option value="swaps">Swaps</option>
  <option value="rounds">Rounds</option>
  <option value="business">Businesses For Sale</option>
</select>

<label style={{ fontWeight: "bold" }}>State:</label>
<select
  value={filters.state}
  onChange={(e) => setFilters({ ...filters, state: e.target.value })}
  style={selectStyle}
>
  <option value="">All</option>
  {options.state.map((opt) => (
    <option key={opt} value={opt}>
      {opt}
    </option>
  ))}
</select>


          <label style={{ fontWeight: "bold" }}>Postcode:</label>
          <input
            type="text"
            value={filters.postcode}
            onChange={(e) =>
              setFilters({ ...filters, postcode: e.target.value })
            }
            placeholder="Enter Postcode"
            style={selectStyle}
          />

          <button
            onClick={() =>
              setFilters({ category: "", type: "", state: "", postcode: "" })
            }
            style={{
              width: "100%",
              padding: "12px",
              backgroundColor: "#d32f2f",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <FaSyncAlt /> Reset Filters
          </button>
        </div>
      </aside>

      {/* Main Listings */}
      <main
  style={{
    flex: 1,
    padding: "20px",
    overflowY: "auto",
    height: "100vh",
  }}
>
        <div
          style={{
            textAlign: "center",
            fontSize: "1.5rem",
            fontWeight: "bold",
            marginBottom: "15px",
            color: "#2e7d32",
          }}
        >
          Available Listings —{" "}
          <span style={{ color: "#333", fontWeight: "normal" }}>
            {filteredListings.length} Results
          </span>
        </div>

        <div
  style={{
    textAlign: "center",
    background: "#eef8f0",
    border: "1px solid #cfe8d3",
    borderRadius: "12px",
    padding: "14px 18px",
    margin: "0 auto 20px",
    maxWidth: "700px",
    color: "#1b5e20",
    fontWeight: "700",
  }}
>
  🚀 Soft Launch: Be among the first contractors to list on Client Exchange.
</div>

        {filteredListings.length === 0 ? (
          <p style={{ textAlign: "center" }}>No listings found.</p>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
              gap: "20px",
            }}
          >
            {filteredListings.map((listing) => (
              <div
                key={listing.id}
                style={{
                  ...cardStyle,
                  border: listing.isSponsored
                    ? "2px solid #2e7d32"
                    : "1px solid #ccc",
                  boxShadow: listing.isSponsored
                    ? "0 0 12px rgba(46,125,50,0.5)"
                    : "0 2px 6px rgba(0,0,0,0.1)",
                }}
              >
                {listing.isSponsored && (
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      left: "10px",
                      backgroundColor: "#2e7d32",
                      color: "#fff",
                      padding: "4px 10px",
                      borderRadius: "6px",
                      fontSize: "0.8rem",
                      fontWeight: "bold",
                    }}
                  >
                    Sponsored
                  </div>
                )}
{/* ⭐ BUY STATUS BADGE — FIXED POSITION + FULL STATES ⭐ */}
{listing.acreage == 1 && (
  <div
    style={{
      position: "absolute",
      top: "10px",
      left: "10px",
      backgroundColor: "#1b5e20",
      color: "#fff",
      padding: "4px 10px",
      borderRadius: "6px",
      fontSize: "0.8rem",
      fontWeight: "bold",
      zIndex: 20,
    }}
  >
    🌿 Acreage
  </div>
)}
{listing.type === "Sell" && (
  <div
    style={{
      position: "absolute",
      top: "10px",
      right: "10px",
      backgroundColor:
        listing.buy_status === "pending"
          ? "#d32f2f"
          : listing.buy_status === "sold"
          ? "#555"
          : "#2e7d32",
      color: "#fff",
      padding: "4px 10px",
      borderRadius: "6px",
      fontSize: "0.8rem",
      fontWeight: "bold",
      display: "flex",
      alignItems: "center",
      gap: "6px",
      zIndex: 20,
    }}
  >
    <FaExchangeAlt style={{ fontSize: "0.75rem" }} />
    {listing.buy_status === "pending" && "Buy in Progress"}
    {listing.buy_status === "available" && "Available"}
    {listing.buy_status === "sold" && "Sold"}
  </div>
)}


                 <img
                  src={listing.image ? listing.image : getImageSrc()}
                  alt={listing.category || "Lawn Mowing"}
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover",
                  }}
                />

                <div style={{ padding: "12px 15px" }}>
                  {/* Title + Verified */}
                  <h2
                    style={{
                      margin: "0 0 4px 0",
                      color: listing.isSponsored ? "#2e7d32" : "#333",
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>{listing.category || "Lawn Mowing"}</span>
                    {(listing.licence_verified === 1 ||
                      listing.licence_verified === "1") && (
                      <span
                        style={{
                          color: "#2e7d32",
                          fontSize: "0.85rem",
                          fontWeight: "600",
                          marginLeft: "6px",
                        }}
                      >
                        ✔ Verified
                      </span>
                    )}
                  </h2>

                  <p
                    style={{
                      margin: "0 0 8px 0",
                      color: "#777",
                      fontSize: "0.8rem",
                      letterSpacing: "0.4px",
                    }}
                  >
                    ID: <strong>{listing.listingId || "N/A"}</strong>
                  </p>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      rowGap: "4px",
                      fontSize: "0.9rem",
                      alignItems: "center",
                      lineHeight: "1.2",
                    }}
                  >
                    <div style={{ color: "#2e7d32", fontWeight: "bold" }}>
                      Sale Price: ${listing.price || "N/A"}
                    </div>

                    <div
                      style={{
                        textAlign: "right",
                        color: "#43a047",
                        fontWeight: "bold",
                      }}
                    >
                      Cut Value: ${listing.cutValue || "N/A"}
                    </div>

                    <div>
                      <FaMapMarkerAlt color="#d32f2f" />{" "}
                      <strong>Suburb:</strong> {listing.suburb || "N/A"}
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <strong>Postcode:</strong> {listing.postcode || "N/A"}
                    </div>

                    <div>
                      <FaClock color="#0288d1" />{" "}
                      {formatDuration(Number(listing.time))}
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <FaCalendarAlt color="#1976d2" />{" "}
                      {listing.frequency || "N/A"}
                    </div>

                  </div>

                  <Link to={`/listing/${listing.id}`}>
                    <button style={viewButton}>View Details</button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>

    </div>
  );
};

export default Listings;
